import React from "react";

const FundemantalIcon = () => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24.00 24.00"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#667085"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M7.35346 3C4.1736 4.67225 2 8.04849 2 11.9412C2 17.4965 6.42691 22 11.8878 22C15.9848 22 19.4998 19.4651 21 15.8529"
          stroke="#667085"
          stroke-width="1.512"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{" "}
        <path
          d="M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2L12 12H22Z"
          stroke="#667085"
          stroke-width="1.512"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{" "}
      </g>
    </svg>
  );
};
export default FundemantalIcon;
